/* eslint-disable no-debugger */
import Constants from '@usas/ui-web/utils/Constants';
import { ageRangeErrors } from '../kendoReports/shared/ReportFilterValidation';

export const localValidate = (formState) => {
  let errors = { ...ageRangeErrors(formState) };

  if (formState.orgUnitId === '') {
    errors.orgUnitId = 'Organization is required';
  }

  if (formState.seasonId < 0 ) {
    errors.seasonId = 'Season Year is required';
  }

  if (formState.seasonId < 0 && formState.startDate === Constants.BLANK_DATE_STRING ) {
    errors.seasonId = 'Select a Season Year or enter a Start Date / End Date';
  }

  if (formState.genders.length === 0) {
    errors.genders = 'At least one competition category must be selected';
  }

  if (formState.minTimeStandard < formState.maxTimeStandard) {
    errors.minTimeStandard = 'Min Time Standard cannot be faster than Max Time Standard';
  }

  return errors;
};

const CompetitionDetailKendoReportValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default CompetitionDetailKendoReportValidation;